import { get, isEmpty } from 'lodash-es';

const AUTH_PATHS_WITH_LOCATION = [
  '/appointment/register',
  '/appointment/login',
  '/membership/register',
  '/membership/login',
];

export function shouldIncludeLastSelectedLocationOnAuth(pathname) {
  return AUTH_PATHS_WITH_LOCATION.includes(pathname);
}

export function getLastSelectedLocationId(appointmentData) {
  const { selectedLocation, locationServices } = appointmentData || {};
  const loc = !isEmpty(selectedLocation) ? selectedLocation : locationServices;
  const id = get(loc, 'id');
  return id ? Number(id) : undefined;
}

/** True when we can call authenticated last-selected-location API. */
export function canUpsertLastSelectedLocation() {
  if (typeof window === 'undefined') return false;
  try {
    return Boolean(
      localStorage.getItem('userToken') || localStorage.getItem('userId'),
    );
  } catch (e) {
    return false;
  }
}

export function normalizeLocationId(locationId) {
  const id = Number(locationId);
  return Number.isFinite(id) && id > 0 ? id : undefined;
}
